import { MessageBar, MessageBarButton, MessageBarType, mergeStyleSets } from '@fluentui/react';
import React from 'react';
import { DefaultLayerHostZ } from 'src/components/base/OverlayProgress';

//TO DO create spicial enum for Type.
export type Type = MessageBarType.error | MessageBarType.warning | MessageBarType.info | MessageBarType.success;


export interface Button {
    key?: string,
    text: string,
    onClick?: () => any;
}

interface MessagePaneProps {
    message: string;
    messageType?: Type;
    buttons: Button[];
    onDismiss?: () => any;
}

const classNames = mergeStyleSets({
    root: {
        width: '100%',
        backgroundColor: 'white',
    },
})

const Colors: { [key in Type]: string } = {
    [MessageBarType.error]: '#fde7e9',
    [MessageBarType.warning]: '#fff4ce',
    [MessageBarType.success]: '#dff6dd',
    [MessageBarType.info]: '#f3f2f1',
};


const MessagePane: React.FC<MessagePaneProps> = ({ message, messageType, buttons, onDismiss }) => {
    const type: Type = messageType ?? MessageBarType.error;
    return (
        <div className={classNames.root} onClick={onDismiss}>
            <MessageBar
                isMultiline={true}
                dismissButtonAriaLabel='Close'
                messageBarType={type}
                actions={
                    buttons?.length ? (
                        <div>
                            {buttons.map(({ text, onClick }, index) => (
                                <MessageBarButton
                                    key={index}
                                    styles={{ root: { backgroundColor: Colors[type] } }}
                                    onClick={onClick}
                                >
                                    {text}
                                </MessageBarButton>
                            ))}
                        </div>
                    ) : undefined
                }
                onDismiss={onDismiss}>
                <span dangerouslySetInnerHTML={{ __html: message.replace(/\n/g, '<br />') }} />
            </MessageBar>
        </div>
    );
}

export default MessagePane;
